const TOOL_CABINET_ROUTE_PATHS = new Set([
    '/userorder_grant',
    '/userorder_box',
    '/road_his',
    '/orderReceive',
    '/orderReceiveUseLog',
    '/box_his',
    '/productRfidList',
    '/rfid_cabinet_config',
    '/box_weight_session',
    '/rfid_cabinet_session',
    '/userorder_box_statistics',
    '/userorder_total',
    '/userorder_borrow_mac_product',
    '/mac_materials',
    '/productalertlog'
]);

const VENDING_LIKE_ROUTE_PATHS = new Set([
    '/userorder',
    '/reimburse',
    '/pickup_code',
    '/pay_code',
    '/business',
    '/machinsales'
]);

function normalizeRoutePath(path) {
    const clean = String(path || '').split(/[?#]/)[0] || '/';
    if (clean.length > 1 && clean.endsWith('/')) {
        return clean.slice(0, -1);
    }
    return clean;
}

function currentMacBigTypeIds() {
    const raw = window.localStorage.getItem('macBigTypeIds');
    if (!raw || raw === 'null' || raw === 'undefined') {
        return [];
    }
    return String(raw)
        .split(',')
        .map(item => Number(String(item).trim()))
        .filter(id => Number.isFinite(id) && id > 0);
}

export function currentBusinessCapabilities() {
    const typeIds = currentMacBigTypeIds();
    const hasToolCabinet = typeIds.includes(9);
    let hasVendingLike = typeIds.some(id => id !== 9);
    if (!hasToolCabinet && !hasVendingLike) {
        hasVendingLike = true;
    }
    return {
        toolCabinet: hasToolCabinet,
        vendingLike: hasVendingLike
    };
}

export function isBusinessRouteAllowed(path) {
    const normalizedPath = normalizeRoutePath(path);
    const capabilities = currentBusinessCapabilities();
    if (TOOL_CABINET_ROUTE_PATHS.has(normalizedPath)) {
        return capabilities.toolCabinet;
    }
    if (VENDING_LIKE_ROUTE_PATHS.has(normalizedPath)) {
        return capabilities.vendingLike;
    }
    return true;
}
